import {
    MapElementProvider,
    type MapElementProviderProps,
} from '../contextProviders/MapElementProvider';
import MapElementModal from '../../../graph/MapElementModal';
import AgentRouter from './AgentRouter';
import { MAP_ELEMENT_TYPES } from '../../../../constants/graph';
import screens from '../common/screens';

const Agent = (props: MapElementProviderProps) => {
    return (
        <MapElementProvider
            {...props}
            defaultScreen={screens.agent}
            elementType={MAP_ELEMENT_TYPES.agent}
        >
            <MapElementModal>
                <AgentRouter />
            </MapElementModal>
        </MapElementProvider>
    );
};

export default Agent;
